export const SCHEDULE_TASK_ACTIONS = {
    DELETE_SCHEDULE: "DELETED_SCHEDULE",
    EDIT_SCHEDULE: "EDIT_SCHEDULE",
};
